import { render, staticRenderFns } from "./completedOrder.vue?vue&type=template&id=520d17c2&scoped=true&"
import script from "./completedOrder.vue?vue&type=script&lang=js&"
export * from "./completedOrder.vue?vue&type=script&lang=js&"
import style0 from "./completedOrder.vue?vue&type=style&index=0&id=520d17c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520d17c2",
  null
  
)

export default component.exports